import { useEffect, useState } from "react";

interface DonutChartProps {
  data: {
    color: string;
    percentage: number;
  }[];
  width?: number;
}

interface StrokeData {
  dashOffset: number;
  dashArray: string;
}

const DonutChart = ({ data, width = 72 }: DonutChartProps) => {
  const circumference = Math.round(Math.PI * width);
  const [strokeData, setStrokeData] = useState<StrokeData[]>([]);
  useEffect(() => {
    const stroke: StrokeData[] = data.map((item) => {
      return {
        dashOffset: 0,
        dashArray: `${Math.round(circumference * item.percentage)} ${Math.round(circumference * (1 - item.percentage))}`,
      };
    });
    for (let i = 0; i < data.length; ++i) {
      if (i > 0) {
        stroke[i].dashOffset = -parseInt(
          stroke[i - 1]?.dashArray?.split(" ")[0],
        );
      }
    }
    setStrokeData(stroke);
  }, [data]);
  return (
    <div className={`overflow-clip`}>
      <svg
        className="w-full h-full"
        viewBox={`0 0 ${width * 3} ${width * 1.5}`}
      >
        {data.map((item, index) => {
          return (
            <circle
              cx="50%"
              cy="100%"
              r={width}
              fill="none"
              stroke={item.color}
              strokeWidth="40"
              strokeDasharray={strokeData[index]?.dashArray}
              strokeDashoffset={strokeData[index]?.dashOffset}
            />
          );
        })}
      </svg>
    </div>
  );
};
export default DonutChart;
